import onboarding from './onboarding'
import jobPoster from './jobPoster'
import jobPosting from './jobPosting'
import satisfactionSurvey from './satisfactionSurvey'
import postApplicant from './postApplicant'
import jobApplication from './jobApplication'
import jobTemplateManagement from './jobTemplateManagement'
import auditLogManagement from './auditLogManagement'
import applicantLock from './applicantLock'
import applicantStatusAutoChange from './applicantStatusAutoChange'
import userManagement from './userManagement'
import roleManagement from './roleManagement'
import hmManagement from './hmManagement'
import companyManagement from './companyManagement'
import employeeManagement from './employeeManagement'
import alumniManagement from './alumniManagement'
import agreement from './agreement'
import notification from './notification'
import applicantStatusNotificationTemplate from './applicantStatusNotificationTemplate'
import jobBoardPointDashboard from './jobBoardPointDashboard'
import weChatTemplate from './weChatTemplate'
import customLandingPage from './customLandingPage'
import agency from './agency'
import customJobDetailPageEdit from './customJobDetailPage'
import companyApprovalManagement from './companyApprovalManagement'
import jobLocationManagement from './jobLocationManagement'
import interviewQuestionTemplateManagement from './interviewQuestionTemplateManagement'
import candidateStatusManagement from './candidateStatusManagement'
import customJobFilter from './customJobFilter'
import sourceChannelManagement from './sourceChannelManagement'
import offerLetterInviteRecordManagement from './offerLetterInviteRecordManagement'
import siteMessageManagement from './siteMessageManagement'
import serviceAccountManagement from './serviceAccountManagement'
import adsTierManagement from './adsTierManagement'
import uploadDataManagement from './uploadDataManagement'
import customCompanyTheme from './customCompanyTheme'
import jobPostingManagement from './jobPostingManagement'
import exportData from './exportData'
import cashPointsManagement from './cashPointsManagement'
import cashOutManagement from './cashOutManagement'
import schoolManagement from './schoolManagement'
import majorManagement from './majorManagement'
import jobPostingChannelAccount from './jobPostingChannelAccount'
import thirdIntegrationConfigManagement from './thirdIntegrationConfigManagement'
import interviewMeetingRoomManagement from './interviewMeetingRoomManagement'
import aiChatbotConfigManagement from './aiChatbotConfigManagement'
import aiAgentManagement from './aiAgentManagement'
import questionnaireManagement from './questionnaireManagement'
import scoreScaleSetting from './scoreScaleSetting'

export default {
  title: '管理后台',
  tab: '管理后台',
  userManagement,
  roleManagement,
  companyManagement,
  auditLogManagement,
  hmManagement,
  jobLocationManagement,
  jobTemplateManagement,
  notification,
  applicantStatusNotificationTemplate,
  applicantLock,
  applicantStatusAutoChange,
  alumniManagement,
  agreement,
  interviewQuestionTemplateManagement,
  emailManagement: {
    title: '编辑邮件模板',
    menu: '邮件模板管理'
  },
  customMobileLandingPage: {
    title: '编辑手机版公司主页',
    menu: '公司主页管理'
  },
  customJobDetailPage: {
    title: '定制职位详情页',
    menu: '定制职位详情页'
  },
  exportData,
  elcExportData: {
    title: '导出申请数据',
    menu: '导出申请数据'
  },
  dashboard: {
    title: '操作中心',
    menu: '操作中心'
  },
  companyData: {
    title: '公司数据',
    menu: '公司数据'
  },
  companyUserData: {
    title: '公司用户数据',
    menu: '公司用户数据'
  },
  candidateStatusManagement,
  vendorManagement: {
    title: '猎头供应商管理',
    menu: '猎头供应商管理'
  },
  customJobFilter,
  weChatTemplateMessageManagement: {
    title: '微信模板消息管理',
    menu: '微信模板消息管理'
  },
  microSiteManagement: {
    title: '微网站管理',
    menu: '微网站管理'
  },
  employeeManagement,
  onboarding,
  jobPoster,
  jobPosting,
  satisfactionSurvey,
  postApplicant,
  jobApplication,
  cashPointsManagement,
  cashOutManagement,
  sourceChannelManagement,
  jobBoardPointDashboard,
  group: {
    recruitManagement: '招聘管理',
    companyInternalManagement: '公司内部管理',
    customerBrandManagement: '雇主品牌管理',
    dataManagement: '数据管理',
    referralManagement: '推荐管理'
  },
  weChatTemplate,
  customLandingPage,
  agency,
  customJobDetailPageEdit,
  companyApprovalManagement,
  offerLetterInviteRecordManagement,
  siteMessageManagement,
  serviceAccountManagement,
  adsTierManagement,
  uploadDataManagement,
  customCompanyTheme,
  jobPostingManagement,
  schoolManagement,
  majorManagement,
  thirdIntegrationConfigManagement,
  jobPostingChannelAccount,
  interviewMeetingRoomManagement,
  aiChatbotConfigManagement,
  aiAgentManagement,
  questionnaireManagement,
  scoreScaleSetting
}
